import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

const useAgencyHasCreativeTemplatesFeature = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const creativeTemplatesAgencies = useSelectorApp(
    (state) => state.ui.agenciesFeatureFlags?.creativeTemplates ?? []
  );

  return creativeTemplatesAgencies.includes(agencyID);
};

export default useAgencyHasCreativeTemplatesFeature;
